import React, { useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import SimpleLayout from "./layouts/SimpleLayout";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Setup from "./pages/Setup/Setup";
import RequireAuth from "./pages/Login/RequireAuth";
import ScenarioSetup from "./pages/Setup/Scenario/ScenarioSetupNew";
import Analyze from "./pages/Analyze/Analyze";
import Approval from "./pages/Approval/Approval";
import QuotaModification from "./pages/Approval/QuotaModification/QuotaModification";
import Scenario from "./pages/Approval/Scenario/Scenario";
import Quota from "./pages/Approval/Quota/Quota";
// import CGPG from "./pages/Approvals/CGPG/CGPG";
import Review from "./pages/Review/Review";
import CustomerGroupSetup from "./pages/Setup/Customer/CustomerGroupSetup";
//import ProductGroupSetup from "./pages/Setup/Product/ProductGroupSetup";
import Define from "./pages/Define/Define";
import Admin from "./pages/Admin/Admin";
import FunctionalAdmin from "./pages/Functionaladmin/FunctionalAdmin";
import UserAdministration from "./pages/Admin/UserAdministration/UserAdministration";
import GroupScenarioActivity from "./pages/Admin/GroupScenarioActivity";
import ApprovalLevels from "./pages/Admin/ApprovalLevel/ApprovalLevels";
import CustomerTrustLevel from "./pages/Functionaladmin/CustomerTrustLevel";
import CustomerRename from "./pages/Functionaladmin/CustomerRename";
import DefineQuota from "./pages/Define/DefineQuota";
import QuotaCopySubmit from "./pages/Define/quotaCopySubmit/QuotaCopySubmit";
import SKU_Replacement from "./pages/Functionaladmin/SKUReplacement/SKU_Replacement";
import UOM from "./pages/Admin/UOM/UOM";
import FAEditScenario from "./pages/Functionaladmin/EditScenario/FAEditScenario";
import FileTransfer from "./pages/FileTransfer/FileTransfer";
import FileInterface from "./pages/FileTransfer/FileInterface";

import ReviewOrdersandQuota from "./pages/Review/reviewOrdersandQuota/ReviewOrdersandQuota";
//import OrderDecision from "./pages/Review/orderDecision/OrderDecision";
//import OrderModification from "./pages/Review/orderModification/OrderModification";
import useDocumentTitle from "./useDocumentTitle";
import axios from "axios";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
//import { reset } from "./pages/Define/defineSlice";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
//import RecordModification from "./pages/Admin/RecordModifications/RecordModifications";
import { setState } from "./store/loginSlice";
import AtaGlance from "./pages/Dashboard/AtaGlance/AtaGlance";

import MSlogin from "./pages/mslogin/mslogin";
import AzureADLogin from "./pages/mslogin/AzureADLogin";

// import SupplyDemand from "./pages/Analyze/supplydemand/SupplyDemand";
import Data from "./pages/Analyze/data/Data";
import NewCustomer from "./pages/Analyze/newcustomer/NewCustomer";
import Customer from "./pages/Analyze/customer/Customer";
import Modifications from "./pages/Analyze/modifications/Modifications";
import TradeDetails from "./pages/Analyze/tradeDetails/TradeDetails";
import IntendedVSDelivered from "./pages/Analyze/intendedVSDelivered/IntendedVSDelivered";
import FourPL from "./pages/Analyze/FourPL/FourPL";
import BackendReport from "./pages/Analyze/GenerateReport/BackendReport";
import GenerateReports from "./pages/Analyze/GenerateReport/GenerateReports";
import QuotaDetails from "./pages/Analyze/quotaDetails/QuotaDetails";
// import BrandOverview from "./pages/Analyze/supplydemand/BrandOverview";
// import PanEU from "./pages/Analyze/supplydemand/PanEU";
// import ExcessCountryBrand from "./pages/Analyze/supplydemand/ExcessCountryBrand";
import QuotaFile from "./pages/FileTransfer/QuotaFile";
import QuotaFileGenerate from "./pages/FileTransfer/QuotaFileGenerate";
import Audit from "./pages/Audit/Audit";
import ModificationInScenario from "./pages/Audit/ModificationInScenario";
import CommentsAndAttachments from "./pages/Audit/CommentsAndAttachments";
import QuotaRunningPeriod from "./pages/Dashboard/QuotaRunningPeriod/QuotaRunningPeriod";
import QuotaNextPeriod from "./pages/Dashboard/QuotaNextPeriod/QuotaNextPeriod";
import { API_URL as baseApiUrl } from "@/config/env";

// const oktaAuth = new OktaAuth({
// 	issuer: "https://amgen.okta.com/oauth2/default",
// 	clientId: "0oa153tm42t3QoXPc0x8",
// 	redirectUri: `${window.location.origin}/implicit/callback`,
// 	scopes: ["openid", "profile", "email"],
// 	pkce: true,
// });

//    `{window.location.origin}/implicit/callback`,
//  "https://wave3.qa-amgensims.solutions.iqvia.com/implicit/callback", - 0oa153tm42t3QoXPc0x8
// "https://www.amgensims.solutions.iqvia.com/implicit/callback" --0oa14uuorlz5NHfLK0x8

function App() {
	const [userinfo, setUserInfo] = React.useState(null);
	const [userRole, setUserRole] = React.useState("");
	const GetUserDetails = (username) => {
		const baseUrl = baseApiUrl + `SSOLogin?email=` + username;
		axios.get(baseUrl, {}).then((response) => {
			if (
				response !== undefined &&
				response !== null &&
				response?.data !== "not exist"
			) {
				//if(email !== response?.data?.email){
				localStorage.setItem("data", JSON.stringify(response?.data));
				localStorage.setItem("lastActiveTime", Date.now().toString());
				if (
					window.location.pathname === "/" ||
					window.location.pathname.includes("implicit/callback")
				) {
					window.location.replace(window.location.origin + "/dashboard");
					dispatch(setState("isLoggedIn", true));
				}
				//}
			}
		});
	};
	useEffect(() => {
		if (
			userinfo !== undefined &&
			userinfo !== null &&
			userinfo?.email !== undefined &&
			userinfo?.email !== null &&
			userinfo?.email !== ""
		) {
			GetUserDetails(userinfo.email);
		}
	}, [userinfo]);
	// const restoreOriginalUri = async (oktaAuth, originalUri) => {
	// 	try {
	// 		let userInfo123 = []; //
	// 		oktaAuth.getUser().then((info) => {
	// 			userInfo123 = info;
	// 			console.log("User info:", userInfo123);
	// 			if (userInfo123 !== null && userInfo123 !== undefined) {
	// 				setUserInfo(userInfo123);
	// 			}
	// 		});
	// 	} catch (e) {
	// 		console.error("Error restoreOriginalUri:", e);
	// 	}
	// };

	const login = useSelector((state) => state.login);
	const { isLoggedIn } = login;
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);


	useEffect(() => {
		// console.log(localStorage.getItem("data"));
		if (localStorage.getItem("data") == null) {
			if (
				window.location.pathname !== "/" &&
				// window.location.pathname !== "/implicit/callback" &&
				window.location.pathname !== "/dashboard" &&
				window.location.pathname !== "/login"
			) {
				dispatch(setState("isLoggedIn", false));
				navigate("/mslogin");
			}
		} else {
			dispatch(setState("isLoggedIn", true));
			setUserRole(data.roleName);
		}
	}, [isLoggedIn]);

	// React.useEffect(() => {
	// 	try {
	// 		if (window.location.pathname === "/") {
	// 			oktaAuth.signInWithRedirect({ originalUri: "/dashboard" }).then(() => {
	// 				return oktaAuth.token.parseFromUrl();
	// 			});
	// 		}
	// 	} catch (e) {
	// 		console.error("Error:", e);
	// 	}
	// }, [navigate]);

	// const handleOktaCallback = async () => {
	// 	try {
	// 		let v = "handleOktaCallback";
	// 		let uril = JSON.stringify(v);
	// 		let obj22 = {
	// 			type: "Info",
	// 			info: "handleOktaCallback",
	// 			jsonlist: uril,
	// 		};
	// 		Logging(obj22);
	// 		const tokens = await oktaAuth.handleLoginRedirect();
	// 		oktaAuth.handleLoginRedirect().then((inj) => {
	// 			console.log(inj);
	// 		});
	// 		if (tokens !== null && tokens !== undefined) {
	// 			const accessToken = tokens.accessToken;
	// 			let uri1 = JSON.stringify(accessToken);
	// 			let obj = {
	// 				type: "Info",
	// 				info: "accessToken",
	// 				jsonlist: uri1,
	// 			};
	// 			Logging(obj);
	// 			const idToken = tokens.idToken;
	// 			let uri2 = JSON.stringify(idToken);
	// 			let obj2 = {
	// 				type: "Info",
	// 				info: "idToken",
	// 				jsonlist: uri2,
	// 			};
	// 			Logging(obj2);
	// 			let userInfo = [];
	// 			oktaAuth.getUser().then((info) => {
	// 				userInfo = info;
	// 				console.log("User info:", userInfo);
	// 				if (userInfo !== null && userInfo !== undefined) {
	// 					let uri3 = JSON.stringify(userInfo);
	// 					let obj3 = {
	// 						type: "Info",
	// 						info: "userInfo",
	// 						jsonlist: uri3,
	// 					};
	// 					Logging(obj3);
	// 					console.log("User info:", userInfo);
	// 					if (userInfo !== null && userInfo !== undefined) {
	// 						setUserInfo(userInfo);
	// 					}
	// 				}
	// 			});
	// 		}
	// 	} catch (error) {
	// 		console.error("Error handling Okta callback:", error);
	// 	}
	// };

	// useEffect(() => {
	// 	handleOktaCallback();
	// }, [oktaAuth]);

	const DoSomethingWrapper = ({ children }) => {
		useEffect(() => {
			//dispatch(reset("onRefresh"));
		}, []);
		return children;
	};

	function Page(props) {
		const titlePrefix = "SIMS ";
		useDocumentTitle(`${titlePrefix}${props.title}`);
		return props.content;
	}

	const Logging = async (obj) => {
		try {
			// Make the POST request
			let url = baseApiUrl + "Home/Logging";
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(obj),
			});

			// Parse the response
			const result = await response.json();

			// Set the response in the state
		} catch (error) {
			console.error("Error making POST request:", error);
		}
	};

	const SetPageTitle = (props) => {
		return <Page content={props.children} title={props.title} />;
	};

	return (
		// <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
		<Routes>
			{/* <Route path="/login/callback" element={<LoginCallback />} /> */}

			<Route path="/login" element={<SimpleLayout />}>
				<Route
					index
					element={
						<SetPageTitle title="">
							<Login />
						</SetPageTitle>
					}
				/>
				<Route
					path={"/login"}
					element={
						<SetPageTitle title="">
							<Login />
						</SetPageTitle>
					}
				/>
			</Route>
			{/* <Route path="/dashboardint" element={<SimpleLayout />}>
          <Route
            index
            element={
              <SetPageTitle title="Dashboard">
                <Dashboard />
              </SetPageTitle>
            }
          />
          <Route
            path={"/dashboardint"}
            element={
              <SetPageTitle title="Dashboard">
                <Dashboard />
              </SetPageTitle>
            }
          />
        </Route> */}

			<Route path="/mslogin" element={<SimpleLayout />}>
				<Route
					index
					element={
						<SetPageTitle title="">
							<AzureADLogin />
						</SetPageTitle>
					}
				/>
				<Route
					path={"/mslogin"}
					element={
						<SetPageTitle title="">
							<AzureADLogin />
						</SetPageTitle>
					}
				/>
			</Route>

			{isLoggedIn && (
				<Route element={<MainLayout />}>
					<Route element={<RequireAuth />}>
						<Route
							index
							element={
								<SetPageTitle title="Dashboard">
									<Dashboard />
								</SetPageTitle>
							}
						/>
						<Route
							path={"/dashboard/*"}
							element={
								<SetPageTitle title="Dashboard">
									<Dashboard />
								</SetPageTitle>
							}
						>
							<Route
								index
								element={<Navigate to={"at-a-glance"} replace />}
							/>
							<Route
								path="at-a-glance"
								element={
									<SetPageTitle>
										<AtaGlance />
									</SetPageTitle>
								}
							/>
							<Route
								index
								element={<Navigate to={"quota-next-period"} replace />}
							/>
							<Route
								path="quota-next-period"
								element={
									<SetPageTitle>
										<QuotaNextPeriod />
									</SetPageTitle>
								}
							/>
							<Route
								index
								element={<Navigate to={"quota-running-period"} replace />}
							/>
							<Route
								path="quota-running-period"
								element={
									<SetPageTitle>
										<QuotaRunningPeriod />
									</SetPageTitle>
								}
							/>
						</Route>
						<Route
							path={"/setup/*"}
							element={
								// <SetPageTitle title="Setup Module">
								<Setup />
								// </SetPageTitle>
							}
						>
							<Route index element={<Navigate to={"scenario"} replace />} />
							<Route
								path={"scenario"}
								element={
									<SetPageTitle title="Scenario Setup">
										<ScenarioSetup />
									</SetPageTitle>
								}
							/>
							<Route
								path={"customer-group"}
								element={
									<SetPageTitle title="Customer-Group Setup">
										<CustomerGroupSetup />
									</SetPageTitle>
								}
							/>
							{/* <Route
                  path={"product-group"}
                  element={
                    <SetPageTitle title="Product-Group Setup">
                      <ProductGroupSetup />
                    </SetPageTitle>
                  }
                /> */}
						</Route>
						<Route
							path={"/analyze/"}
							element={
								<SetPageTitle title="Analyze">
									<Analyze />
								</SetPageTitle>
							}
						>
							{/* <Route index element={<Navigate to={"data"} replace />} />
								<Route
									path="data"
									element={
										<SetPageTitle title="Analyze Data">
											<Data />
										</SetPageTitle>
									}
								/>
								<Route
									path="new-customer"
									element={
										<SetPageTitle title="New Customer">
											<NewCustomer />
										</SetPageTitle>
									}
								/>
								<Route
									path="customer"
									element={
										<SetPageTitle title="Customer">
											<Customer />
										</SetPageTitle>
									}
								/>
								<Route
									path="quota-details"
									element={
										<SetPageTitle title="Quota Details">
											<QuotaDetails />
										</SetPageTitle>
									}
								/>
								<Route
									path="modifications"
									element={
										<SetPageTitle title="Modifications">
											<Modifications />
										</SetPageTitle>
									}
								/>
								<Route
									path="trade-details"
									element={
										<SetPageTitle title="Trade Details">
											<TradeDetails />
										</SetPageTitle>
									}
								/>
								<Route
									path="intended-vs-delivered"
									element={
										<SetPageTitle title="Intended VS Delivered">
											<IntendedVSDelivered />
										</SetPageTitle>
									}
								/>
								<Route
									path="3pl-export-partner"
									element={
										<SetPageTitle title="3PL Export Partner">
											<FourPL />
										</SetPageTitle>
									}
								/>
								<Route
									path="backend-reports"
									element={
										<SetPageTitle title="Backend Reports">
											<BackendReport />
										</SetPageTitle>
									}
								/>
								<Route
									path="generate-reports"
									element={
										<SetPageTitle title="Generate Reports">
											<GenerateReports />
										</SetPageTitle>
									}
								/>
								<Route
									path="supply-demand"
									element={
										<SetPageTitle title="Supply Demand">
											<SupplyDemand />
										</SetPageTitle>
									}
								>
									<Route
										index
										element={<Navigate to={"brand-overview"} replace />}
									/>
									<Route
										path="brand-overview"
										element={
											<SetPageTitle title="Brand Overview">
												<BrandOverview />
											</SetPageTitle>
										}
									/>
									<Route
										path="pan-eu-brand-overview"
										element={
											<SetPageTitle title="Pan EU Brand Overview">
												<PanEU />
											</SetPageTitle>
										}
									/>
									<Route
										path="excess-country-brand"
										element={
											<SetPageTitle title="Excess Country-Brand">
												<ExcessCountryBrand />
											</SetPageTitle>
										}
									/>
								</Route> */}
						</Route>

						<Route
							path={"/approval/*"}
							element={
								// <SetPageTitle title="Quota-Modification-Approval">
								<Approval />
								// </SetPageTitle>
							}
						>
							<Route
								index
								element={<Navigate to={"quota-modification"} replace />}
							/>
							<Route
								path={"quota-modification"}
								element={
									<SetPageTitle title="Quota-Modification-Approval">
										<QuotaModification />
									</SetPageTitle>
								}
							/>
							{/* <Route
                path={"quota-modification/:paramsCountryID"}
                element={
                  <SetPageTitle title="Quota-Modification-Approval">
                    <QuotaModification />
                  </SetPageTitle>
                }
              /> */}
							<Route
								path={"scenario"}
								element={
									<SetPageTitle title="Scenario-Approval">
										<Scenario />
									</SetPageTitle>
								}
							/>
							<Route
								path={"scenario/:paramsCountryID"}
								element={
									<SetPageTitle title="Scenario-Approval">
										<Scenario />
									</SetPageTitle>
								}
							/>
							<Route
								path={"quota"}
								element={
									<SetPageTitle title="Quota-Approval">
										<Quota />
									</SetPageTitle>
								}
							/>
							{/* <Route
                path={"quota/:paramsCountryID"}
                element={
                  <SetPageTitle title="Quota-Approval">
                    <Quota />
                  </SetPageTitle>
                }
              /> */}
							{/* <Route
									path={"customer-product"}
									element={
										<SetPageTitle title="Customer-Product">
											<CGPG />
										</SetPageTitle>
									}
								/> */}
						</Route>

						<Route
							path={"/filetransfer/*"}
							element={
								<SetPageTitle title="File Transfer">
									<FileTransfer />
								</SetPageTitle>
							}
						>
							<Route
								index
								element={<Navigate to={"fileinterface"} replace />}
							/>
							<Route
								path={"fileinterface"}
								element={
									<SetPageTitle title="File Transfer">
										<FileInterface />
									</SetPageTitle>
								}
							/>
							<Route
								path={"quotafile"}
								element={
									<SetPageTitle title="Quota File Generation">
										<QuotaFile />
									</SetPageTitle>
								}
							/>
							<Route
								path={"quotafilegenerate"}
								element={
									<SetPageTitle title="Quota File Generation New">
										<QuotaFileGenerate />
									</SetPageTitle>
								}
							/>
						</Route>

						<Route
							path={"/define/*"}
							element={
								<DoSomethingWrapper>
									<Define />
								</DoSomethingWrapper>
							}
						>
							<Route index element={<Navigate to={"quota"} replace />} />
							<Route
								path={"quota"}
								element={
									<SetPageTitle title="Define-Quota">
										<DefineQuota />
									</SetPageTitle>
								}
							/>
							<Route
								path={"quota-copy-submit"}
								element={
									<SetPageTitle title="Define-Copy & Submit">
										<QuotaCopySubmit />
									</SetPageTitle>
								}
							/>
						</Route>

						<Route
							path={"/review/*"}
							element={
								<SetPageTitle title="Review Order & Quota">
									<Review />
								</SetPageTitle>
							}
						>
							<Route index element={<Navigate to={"order"} replace />} />
							<Route
								path={"order"}
								element={
									<SetPageTitle title="Review Order & Quota">
										<ReviewOrdersandQuota />
									</SetPageTitle>
								}
							/>
							{/* <Route
                  path={"exportmodifiedorder"}
                  element={
                    <SetPageTitle title="Export Modified Order">
                      <OrderDecision />
                    </SetPageTitle>
                  }
                /> */}
							{/* <Route
                  path={"ordermodification"}
                  element={
                    <SetPageTitle title="Order Modifications by Customer">
                      <OrderModification />
                    </SetPageTitle>
                  }
                /> */}
						</Route>
						<Route
							path={"/functionaladmin/*"}
							element={
								// <SetPageTitle title="Functional Admin">
								<FunctionalAdmin />
								// </SetPageTitle>
							}
						>
							<Route
								index
								element={<Navigate to={"Customer_Rename"} replace />}
							/>
							<Route
								path={"Customer_Rename"}
								element={
									<SetPageTitle title="Customer Rename">
										<CustomerRename />
									</SetPageTitle>
								}
							/>
							<Route
								path={"SKU_Replacement"}
								element={
									<SetPageTitle title="SKU-Replacement-Tab">
										<SKU_Replacement />
									</SetPageTitle>
								}
							/>
							<Route
								path={"Customer_Trust_Level"}
								element={
									<SetPageTitle title="Customer Trust Level">
										<CustomerTrustLevel />
									</SetPageTitle>
								}
							/>
							<Route
								path={"edit_Scenario"}
								element={
									<SetPageTitle title="Edit Scenario">
										<FAEditScenario />
									</SetPageTitle>
								}
							/>
						</Route>
						<Route
							path={"/admin/*"}
							element={
								// <SetPageTitle title="User-Administrator-Tab">
								<Admin />
								// </SetPageTitle>
							}
						>

															
								{/* <Route index element={<Navigate to={"user_admin"} replace />} />
								<Route
									path={"user_admin"}
									element={
										<SetPageTitle title="User-Administrator-Tab">
											<UserAdministration />
										</SetPageTitle>
									}
								/>  */}




							{/* <Route path="/admin/*" element={<Admin />}> */}
								<Route index element={<Navigate to="user_admin" replace />} />
								<Route
									path="user_admin"
									element={
										userRole === "Administrator" ? (
											<SetPageTitle title="User-Administrator-Tab">
												<UserAdministration />
											</SetPageTitle>
										) : (
											<Navigate to="/mslogin" replace />
										)
									}
								/>
							{/* </Route> */}



							<Route
								path={"approval"}
								element={
									<SetPageTitle title="Approval-Level-Tab">
										<ApprovalLevels />
									</SetPageTitle>
								}
							/>

							<Route
								path={"UOM"}
								element={
									<SetPageTitle title="UOM-Tab">
										<UOM />
									</SetPageTitle>
								}
							/>
							{/* <Route
                  path={"Record_Modification"}
                  element={
                    <SetPageTitle title="Records-Modification-Tab">
                      <RecordModification />
                    </SetPageTitle>
                  }
                /> */}
							<Route
								path={"Group_Scenario_Activity"}
								element={
									<SetPageTitle title="Group-Scenario-Tab">
										<GroupScenarioActivity />
									</SetPageTitle>
								}
							/>
						</Route>

						<Route
							path={"/audit/*"}
							element={
								// <SetPageTitle title="Functional Admin">
								<Audit />
								// </SetPageTitle>
							}
						>
							<Route
								index
								element={<Navigate to={"Modifications_Scenario"} replace />}
							/>
							<Route
								path={"Modifications_Scenario"}
								element={
									<SetPageTitle title="Modifications in Scenario">
										<ModificationInScenario />
									</SetPageTitle>
								}
							/>
							<Route
								path={"Comments_Attachments"}
								element={
									<SetPageTitle title="Comments and Attachments">
										<CommentsAndAttachments />
									</SetPageTitle>
								}
							/>
						</Route>
					</Route>
				</Route>
			)}
		</Routes>
		// </Security>
	);
}

export default App;
